import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_FETCH_ALL_WALLET_TO_WALLET } from "../../../config/api";

export const fetchAllWalletToWallet = createAsyncThunk(
  "fetchAllWalletToWallet/getAll",
  async ({ cb, failed }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_FETCH_ALL_WALLET_TO_WALLET,
      });
      cb();

      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(msg);
    }
  }
);
